import {Box, CenterBox} from '@buncha/components/core/view';

import {B2BUserScreens} from '@buncha/B2B/navigation/types';
import {H5Text} from '@buncha/components/core/text';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import OrderHeader from '../orderHeader/OrderHeader';
import React from 'react';
import {StyleSheet} from 'react-native';
import {useGetLocale} from '@buncha/localization/hooks';

interface NoDataFoundProps {
  title?: string;
  hideHeader?: boolean;
}

const NoDataFound: React.FC<NoDataFoundProps> = props => {
  const {body} =
    useGetLocale(Modules.B2BUserOrder, B2BUserScreens.OrderInfo) ?? {};
  return (
    <Box style={styles.flexStyle}>
      <If condition={!props?.hideHeader}>
        <OrderHeader />
      </If>
      <CenterBox style={styles.flexStyle}>
        <H5Text>{props?.title ?? body?.NoPageData}</H5Text>
      </CenterBox>
    </Box>
  );
};

export default React.memo(NoDataFound);

const styles = StyleSheet.create({
  flexStyle: {flex: 1},
});
